export default __webpack_public_path__ + "static/qrcode-min-22ae2d4cdc530a12df4c8ec07dbd04c2.jpg";